module.exports = __webpack_public_path__ + "media/images/pc/plans/search_form/costume_type_kimono-0061b42d2ac8d7c0f5d16a1bc2a2863a.webp";